var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane active",attrs:{"role":"tabpanel"}},[_c('FormEventPeriod',{attrs:{"title":"Event Title","users-beginngin-of-week":_vm.usersBeginnginOfWeek}}),_vm._v(" "),_c('FormCta')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }